// The app's single react-query client. Its own module (not App.tsx) so the
// session code can clear it: the cache holds identity- and scope-bearing
// responses, including signed live-view URLs, stream tokens and presigned
// recording URLs, and must not outlive the session that fetched them
// (store/session.ts).
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
